import * as React from 'react';
import {
  PageTypeEnum,
  SampleTypeLandingMapping,
  SpeakingSampleTypeEnum,
  SpeakingSampleTypeTitle,
  WritingSampleTypeEnum,
  WritingSampleTypeTitle,
  K12TestTypeContent,
  K12OtherCoursesSubjectNameMapping,
} from '@doltech/utils/lib/constants';
import { buildUrl } from '@doltech/utils/lib/url';
import { environment } from '@doltech/core/lib/environment/environment';

const getSchemaK12 = ({ title = '', pageUrl = null, search = null, breadcrumbs = [] }) => {
  return {
    K12_LANDING: search
      ? {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'DOL Academy',
              item: environment.SEO_PREFIX,
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'Luyện Thi THPTQG',
              item: `${environment.SEO_PREFIX}thptqg`,
            },
            {
              '@type': 'ListItem',
              position: 3,
              name: title,
              item: buildUrl(environment.SEO_REDIRECT_TU_HOC_IELTS, pageUrl),
            },
            {
              '@type': 'ListItem',
              position: 4,
              name: !isNaN(search) ? search : K12TestTypeContent[search],
            },
          ],
        }
      : {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'DOL Academy',
              item: environment.SEO_PREFIX,
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'Luyện Thi THPTQG',
              item: `${environment.SEO_PREFIX}thptqg`,
            },
            {
              '@type': 'ListItem',
              position: 3,
              name: title,
            },
          ],
        },
    K12_BOOK: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'DOL Academy',
          item: environment.SEO_PREFIX,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Luyện Thi THPTQG',
          item: `${environment.SEO_PREFIX}thptqg`,
        },
        ...(breadcrumbs?.map((crumb, idx) => {
          return {
            '@type': 'ListItem',
            position: idx + 3,
            name:
              crumb?.type === 'SUBJECT' ? K12OtherCoursesSubjectNameMapping[crumb?.name] : crumb?.name,
            item: buildUrl(environment.SEO_REDIRECT_TU_HOC_IELTS, `${crumb?.url}`),
          };
        }) || []),
        {
          '@type': 'ListItem',
          position: 5,
          name: title,
        },
      ],
    },
    K12_EXAM: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'DOL Academy',
          item: environment.SEO_PREFIX,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Luyện Thi THPTQG',
          item: `${environment.SEO_PREFIX}thptqg`,
        },
        ...(breadcrumbs?.map((crumb, idx) => {
          return {
            '@type': 'ListItem',
            position: idx + 3,
            name:
              crumb?.type === 'SUBJECT' ? K12OtherCoursesSubjectNameMapping[crumb?.name] : crumb?.name,
            item: buildUrl(environment.SEO_REDIRECT_TU_HOC_IELTS, `${crumb?.url}`),
          };
        }) || []),
        {
          '@type': 'ListItem',
          position: 6,
          name: title,
        },
      ],
    },
  };
};
const getSchemaSample = (title, sampleType, staticPageLink) => {
  return {
    SPEAKING_SAMPLE: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'TRANG CHỦ',
          item: environment.SEO_PREFIX,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'IELTS SPEAKING SAMPLE',
          item: `${environment.SEO_PREFIX}category/tong-hop-bai-mau-ielts-speaking-sample`,
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: SpeakingSampleTypeTitle[sampleType],
          item:
            buildUrl(
              environment.SEO_REDIRECT_TU_HOC_IELTS,
              staticPageLink?.[SampleTypeLandingMapping[sampleType]]?.url
            ) || '/',
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: title,
        },
      ],
    },
    WRITING_SAMPLE: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'TRANG CHỦ',
          item: environment.SEO_PREFIX,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'IELTS WRITING SAMPLE',
          item: `${environment.SEO_PREFIX}category/tong-hop-sample-ielts-writing`,
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: WritingSampleTypeTitle[sampleType],
          item:
            buildUrl(
              environment.SEO_REDIRECT_TU_HOC_IELTS,
              staticPageLink?.[SampleTypeLandingMapping[sampleType]]?.url
            ) || '/',
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: title,
        },
      ],
    },
  };
};
const getSchema = (title, book = null) => {
  return {
    READING: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'TRANG CHỦ',
          item: environment.SEO_PREFIX,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'IELTS ONLINE TEST',
          item: `${environment.SEO_PREFIX}luyen-thi-ielts/free-ielts-online-test`,
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: 'IELTS READING PRACTICE TESTS',
          item: `${environment.SEO_PREFIX}luyen-thi-ielts/ielts-reading-practice`,
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: title,
        },
      ],
    },
    LISTENING: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'TRANG CHỦ',
          item: environment.SEO_PREFIX,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'IELTS ONLINE TEST',
          item: `${environment.SEO_PREFIX}luyen-thi-ielts/free-ielts-online-test`,
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: 'IELTS LISTENING PRACTICE TESTS',
          item: `${environment.SEO_PREFIX}luyen-thi-ielts/ielts-listening-practice`,
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: title,
        },
      ],
    },
    FULL: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'TRANG CHỦ',
          item: environment.SEO_PREFIX,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'IELTS ONLINE TEST',
          item: `${environment.SEO_PREFIX}luyen-thi-ielts/free-ielts-online-test`,
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: book?.name,
          item: buildUrl(environment.SEO_REDIRECT_TU_HOC_IELTS, book?.url) || '/',
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: title,
        },
      ],
    },
  };
};

interface LandingJsonLdSchemaProps {
  urlInfo?: any;
  sampleType?: WritingSampleTypeEnum | SpeakingSampleTypeEnum;
  staticPageLink?: any;
  pageData?: any;
}

export const useLandingJsonLdSchemaForDolAcademy = ({
  urlInfo,
  sampleType = null,
  staticPageLink = null,
  pageData,
}: LandingJsonLdSchemaProps) => {
  const urlInfoTitle = urlInfo?.dol?.title || urlInfo?.thirdParty?.title;

  let schema = null;
  switch (urlInfo?.type) {
    case PageTypeEnum.VIEW_TEST_QUESTION:
    case PageTypeEnum.VIEW_SOLUTION:
    case PageTypeEnum.VIEW_VOCAB:
    case PageTypeEnum.DO_TEST:
      if (urlInfo?.data?.testType === 'PRACTICE_TEST') {
        if (urlInfo?.data?.skill === 'LISTENING') {
          schema = getSchema(urlInfoTitle)?.LISTENING;
          break;
        }
        if (urlInfo?.data?.skill === 'READING') {
          schema = getSchema(urlInfoTitle)?.READING;
          break;
        }
      }
      if (urlInfo?.data?.testType === 'FULL_TEST') {
        schema = getSchema(urlInfoTitle, urlInfo?.book)?.FULL;
        break;
      }
      break;
    case PageTypeEnum.SPEAKING_SAMPLE_DETAIL:
      schema = getSchemaSample(urlInfoTitle, sampleType, staticPageLink)?.SPEAKING_SAMPLE;
      break;
    case PageTypeEnum.WRITING_SAMPLE_DETAIL:
      schema = getSchemaSample(urlInfoTitle, sampleType, staticPageLink)?.WRITING_SAMPLE;
      break;
    case PageTypeEnum.LAND_K12_INFORMATICS_EXAM_BOOK:
    case PageTypeEnum.LAND_K12_INDUSTRIAL_TECHNOLOGY_EXAM_BOOK:
    case PageTypeEnum.LAND_K12_AGRICULTURAL_TECHNOLOGY_EXAM_BOOK:
    case PageTypeEnum.LAND_K12_CIVIC_EDUCATION_EXAM_BOOK:
    case PageTypeEnum.LAND_K12_HISTORY_EXAM_BOOK:
    case PageTypeEnum.LAND_K12_GEOGRAPHY_EXAM_BOOK:
    case PageTypeEnum.LAND_K12_BIOLOGY_EXAM_BOOK:
    case PageTypeEnum.LAND_K12_CHEMISTRY_EXAM_BOOK:
    case PageTypeEnum.LAND_K12_PHYSICS_EXAM_BOOK:
    case PageTypeEnum.LAND_K12_MATH_EXAM_BOOK:
    case PageTypeEnum.LAND_K12_EXAM_BOOK:
      schema = getSchemaK12({
        title: urlInfoTitle,
        pageUrl: urlInfo?.url,
        search: urlInfo?.search,
      })?.K12_LANDING;
      break;
    case PageTypeEnum.K12_INFORMATICS_EXAM_BOOK:
    case PageTypeEnum.K12_INDUSTRIAL_TECHNOLOGY_EXAM_BOOK:
    case PageTypeEnum.K12_AGRICULTURAL_TECHNOLOGY_EXAM_BOOK:
    case PageTypeEnum.K12_CIVIC_EDUCATION_EXAM_BOOK:
    case PageTypeEnum.K12_HISTORY_EXAM_BOOK:
    case PageTypeEnum.K12_GEOGRAPHY_EXAM_BOOK:
    case PageTypeEnum.K12_BIOLOGY_EXAM_BOOK:
    case PageTypeEnum.K12_CHEMISTRY_EXAM_BOOK:
    case PageTypeEnum.K12_PHYSICS_EXAM_BOOK:
    case PageTypeEnum.K12_MATH_EXAM_BOOK:
    case PageTypeEnum.K12_EXAM_BOOK:
      schema = getSchemaK12({
        title: pageData?.bookInfo?.title,
        pageUrl: urlInfo?.url,
        breadcrumbs: urlInfo?.breadcrumbs,
      })?.K12_BOOK;
      break;
    case PageTypeEnum.K12_DO_TEST:
    case PageTypeEnum.K12_VIEW_SOLUTION:
    case PageTypeEnum.K12_VIEW_TEST_QUESTION:
    case PageTypeEnum.K12_ALL_DO_TEST:
    case PageTypeEnum.K12_ALL_VIEW_SOLUTION:
    case PageTypeEnum.K12_ALL_VIEW_TEST_QUESTION:
      schema = getSchemaK12({
        title: urlInfoTitle,
        pageUrl: urlInfo?.url,
        breadcrumbs: urlInfo?.breadcrumbs,
      })?.K12_EXAM;
      break;
  }

  if (!schema) {
    return;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};
